<template>
<div id="users">

  <h2>Users</h2>

  <user-nav></user-nav>

  <user-search
    filterByStaff
  />

  <div
    class="form-group text-right"
  >
    <label
      class="form-check-label"
      for="suspended"
    >
      <input
        type="checkbox"
        class="form-input-checkbox"
        id="suspended"
        v-model="suspended"
      /> Suspended Email Users Only?
    </label>
  </div>

  <hr />

  <pagination
    :pageResponse="pageResponse"
    :pageSize="$root.defaultPageSize"
    :resourceUrl="resourceUrl"
    orderBy="created_at"
    orderType="DESC"
    ref="pagination"
    preserveHistory
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{
          name: 'user', params: { userId: item.id }
        }"
      >
        {{ item.username }}
        <span
          class="badge badge-success"
          v-if="item.active_subscriber"
        >
          Subscriber
        </span>
        <span
          class="badge badge-danger ml-1"
          v-if="item.email_suspended"
        >
          Email Suspended
        </span>
        <span
          class="badge badge-warning"
          v-if="item.featured"
        >
          Featured
        </span>
        <span
          class="badge badge-info"
          v-if="item.staff"
        >
          Staff
        </span>
        <span
          class="badge badge-primary"
          v-if="item.verified"
        >
          Verified
        </span>
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import UserNav from '@/components/UserNav'
import UserSearch from '@/components/UserSearch'

export default {
  data () {
    return {
      pageResponse: {},
      suspended: false
    }
  },

  components: {
    pagination: Pagination,
    'user-nav': UserNav,
    'user-search': UserSearch
  },

  computed: {
    resourceUrl () {
      return this.apiUrl(this.usersPath, true)
    },

    usersPath () {
      return this.suspended ? '/suspended_email_users' : '/users'
    }
  },

  created () {
    this.$on('searchComplete', this.processPagedResponse)
  },

  methods: {
    processPagedResponse (response) {
      this.$emit('processPagedResponse', response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users.vue